module.exports = __webpack_public_path__ + "img/logo.320ad044.svg";